module.exports = __webpack_public_path__ + "img/topup.e45699ed.svg";